(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-hc-slider]').forEach(function (slider) {
    var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-hc-slide]'));
    var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-hc-dot]'));
    var previous = slider.querySelector('[data-hc-prev]');
    var next = slider.querySelector('[data-hc-next]');
    var status = slider.querySelector('[data-hc-status]');
    var active = 0;
    var timer = null;
    var shouldAutoplay = slider.dataset.hcAutoplay === 'true' && !reduceMotion.matches;
    var delay = Math.max(3000, Number(slider.dataset.hcAutoplayDelay) || 3000);
    if (slides.length < 2) return;

    function show(index, announce) {
      active = (index + slides.length) % slides.length;
      slides.forEach(function (slide, position) {
        var isActive = position === active;
        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      dots.forEach(function (dot, position) {
        dot.setAttribute('aria-selected', String(position === active));
      });
      slider.setAttribute('data-hc-tone', slides[active].classList.contains('hc-hero__slide--ink') ? 'ink' : 'light');
      if (status) {
        var heading = slides[active].querySelector('h1, h2');
        status.setAttribute('aria-live', announce ? 'polite' : 'off');
        status.textContent = 'Destacado ' + (active + 1) + ' de ' + slides.length + (heading ? ': ' + heading.textContent.trim() : '');
      }
    }

    function stopTimer() {
      if (timer) window.clearTimeout(timer);
      timer = null;
    }

    function startTimer() {
      stopTimer();
      if (!shouldAutoplay || document.hidden) return;
      timer = window.setTimeout(function () {
        show(active + 1, false);
        startTimer();
      }, delay);
    }

    function manualChange(index) {
      show(index, true);
      startTimer();
    }

    if (previous) previous.addEventListener('click', function () { manualChange(active - 1); });
    if (next) next.addEventListener('click', function () { manualChange(active + 1); });
    dots.forEach(function (dot, position) { dot.addEventListener('click', function () { manualChange(position); }); });
    slider.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); manualChange(active - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); manualChange(active + 1); }
    });
    slider.addEventListener('mouseenter', stopTimer);
    slider.addEventListener('mouseleave', startTimer);
    slider.addEventListener('focusin', stopTimer);
    slider.addEventListener('focusout', function (event) {
      if (!slider.contains(event.relatedTarget)) startTimer();
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopTimer(); else startTimer();
    });
    reduceMotion.addEventListener('change', function () {
      shouldAutoplay = slider.dataset.hcAutoplay === 'true' && !reduceMotion.matches;
      startTimer();
    });
    show(0, false);
    startTimer();
  });

  document.querySelectorAll('[data-hot-deals-modal]').forEach(function (modal) {
    var dialog = modal.querySelector('[role="dialog"]');
    var previousFocus = null;
    function openModal() {
      previousFocus = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hc-modal-open');
      window.setTimeout(function () {
        var target = dialog.querySelector('[data-hot-deals-success]') || modal.querySelector('.hd-modal__close');
        if (target) target.focus();
      }, 0);
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hc-modal-open');
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }
    document.querySelectorAll('[data-hot-deals-open]').forEach(function (trigger) { trigger.addEventListener('click', openModal); });
    modal.querySelectorAll('[data-hot-deals-close]').forEach(function (trigger) { trigger.addEventListener('click', closeModal); });
    modal.addEventListener('keydown', function (event) { if (event.key === 'Escape') closeModal(); });
    if (modal.querySelector('[data-hot-deals-success]') || modal.querySelector('.hd-form__errors')) openModal();
    modal.querySelectorAll('[data-hot-deals-copy]').forEach(function (button) {
      button.addEventListener('click', function () {
        var code = modal.querySelector('[data-hot-deals-code]');
        if (!code || !navigator.clipboard) return;
        navigator.clipboard.writeText(code.textContent.trim()).then(function () { button.textContent = 'Código copiado'; });
      });
    });
    if (dialog) dialog.addEventListener('click', function (event) { event.stopPropagation(); });
  });
})();
